import { formatArgValue, HIDDEN_ARG_KEYS, translateArgLabel } from '../../nucleo/acoesDaNyta';

// O CARTÃO DA AÇÃO DA NYTA, sem tela: o módulo que cada ferramenta toca e os campos que a pessoa
// autoriza. Mora fora do hook da conversa para a conversa de exemplo (landing e Início) montar o
// cartão com a MESMA regra da conversa de verdade: o exemplo não pode mostrar um cartão que a
// Nyta não mostraria.

/** O módulo que cada ferramenta da Nyta toca (a explicação da ação e o "abrir o módulo"). */
const MODULO_DA_FERRAMENTA: [RegExp, string, string][] = [
  [/catalog/, 'Músicas', 'catalog'],
  [/event/, 'Agenda', 'agenda'],
  [/team/, 'Equipe', 'team'],
  [/strategic_planning/, 'Planejamento', 'desenvolvimento/planejamento'],
  [/plan_task|strategy|create_task/, 'Plano de ação', 'desenvolvimento/plano'],
  [/file/, 'Arquivos', 'arquivos'],
];

/** O módulo da ferramenta: [padrão, nome do módulo, caminho dele no perfil]. */
export const moduloDa = (nome: string) => MODULO_DA_FERRAMENTA.find(([re]) => re.test(nome)) ?? null;

/** Os campos do cartão, na ordem dos argumentos, sem os ids. */
export const camposDa = (args: Record<string, unknown>): { rotulo: string; valor: string; lista?: string[] }[] => Object.entries(args)
  .filter(([chave]) => !HIDDEN_ARG_KEYS.has(chave))
  .map(([chave, valor]) => (Array.isArray(valor)
    ? { rotulo: translateArgLabel(chave), valor: '', lista: (valor as unknown[]).map((v) => formatArgValue(v)) }
    : { rotulo: translateArgLabel(chave), valor: formatArgValue(valor, chave) }));
